<template>
	<div class="">
		<div class="text-center mb-2">اقلام صورتحساب</div>
		<v-divider></v-divider>
		<div class="text-center mt-3" style="overflow-y: auto;">
			<table style="width: 80%;margin: auto;min-width: 300px;">
				<thead>
					<tr>
						<th style="width: 60%;border-bottom: 1px solid grey;">شرح</th>
						<th style="border-bottom: 1px solid grey;">فی (تومان)</th>
						<th style="border-bottom: 1px solid grey;">تعداد</th>
						<th style="border-bottom: 1px solid grey;"></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in items || []" :key="item.id + index">
						<td style="border-bottom: 1px solid #ddd;" class="pt-3"><v-text-field outlined dense class="right-input" v-model="item.product" label="شرح کالا/خدمات" :error-messages="errorMessages" :rules="[(val) => !!val || 'شرح کالا/خدمات را وارد کنید']" required /></td>
						<td style="border-bottom: 1px solid #ddd;" class="pt-3"><v-text-field outlined dense class="center-input" type="number" v-model="item.count" label="تعداد" :error-messages="errorMessages" :rules="[(val) => val > 0 || 'تعداد را به صورت صحیح وارد کنید']" required @input="updateAmount()" /></td>
						<td style="border-bottom: 1px solid #ddd;" class="pt-3"><v-text-money outlined dense class="center-input" v-model="item.fee" label="فی" :error-messages="errorMessages" :rules="[(val) => items[index].fee > 0 || 'فی را به صورت صحیح وارد کنید']" required @change="updateAmount()" /></td>
						<td style="border-bottom: 1px solid #ddd;">
							<v-btn icon v-if="localData.id === emptyId"><v-icon small color="red" @click="removeRow(index)">mdi-close</v-icon></v-btn>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="text-center py-3 mb-3" v-if="localData.id === emptyId">
				<v-btn small color="secondary" @click="addRow()">افزودن ردیف</v-btn>
			</div>
		</div>
	</div>
</template>

<script>


	export default {
		name: 'ProductRows',
		components: {

		},
		props: {
			options: {
				type: Object,
				default: () => { return { rangeMode: false, defaultEmpty: false } },
			},
			value: {
				type: Object
			},
			rows: {
				type: Array
			}
		},
		data: () => ({
			items: [],
		}),
		created() {

		},
		watch: {
			rows: {
				immediate: true,
				deep: true,
				handler(newRows) {
					// Clone the array and its item objects to avoid mutating the prop
					this.items = (newRows || []).map(row => ({ ...row }))
				}
			}
		},
		methods: {
			emitValue() {
				this.$emit('input', this.items)
			},
			addRow() {
				if (!this.items)
					this.items = []
				this.items.push({ id: emptyId, product: '', count: 1, fee: 0 })
				this.emitValue()
			},
			removeRow(index) {
				this.items.splice(index, 1)
				this.updateAmount()
				this.emitValue()
			},
			updateAmount() {
				this.amount = (this.items || []).reduce((sum, item) => sum + (Number(item.count || 0) * Number(item.fee || 0)), 0)
			}
		}
	}
</script>
